import { useCallback, useState } from 'react';
import { useSendMasterDocuments } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentsModal/api/useSendMasterDocuments';
import type {
	SendDocumentsRecipients,
	SendDocumentsStep,
} from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Modals/SendDocumentsModal/SendDocumentsModal.types';

export const useSendDocumentsController = (recipients: SendDocumentsRecipients) => {
	const [step, setStep] = useState<SendDocumentsStep>('pick');
	const [selectedIds, setSelectedIds] = useState<string[]>([]);
	const [emailText, setEmailText] = useState('');

	const { mutateAsync, isPending } = useSendMasterDocuments();

	const send = useCallback(async () => {
		const documents = selectedIds.map((templateId) => ({
			documentWorkflowTemplateId: templateId,
		}));

		try {
			await mutateAsync({
				documents,
				...(emailText.length > 0 ? { emailText } : {}),
				...(recipients.bulkActionPayload ?? {
					selectedIds: recipients.selectedInvestorsIds,
				}),
			});
			setStep('success');
		} catch {
			// useSendMasterDocuments has already toasted; stay on confirm so it can be retried.
		}
	}, [selectedIds, emailText, recipients, mutateAsync]);

	const sendAnother = useCallback(() => {
		setSelectedIds([]);
		setEmailText('');
		setStep('pick');
	}, []);

	return {
		step,
		selectedIds,
		emailText,
		isSending: isPending,
		setSelectedIds,
		setEmailText,
		goToConfirm: useCallback(() => setStep('confirm'), []),
		goBackToPick: useCallback(() => setStep('pick'), []),
		send,
		sendAnother,
	};
};
